import clsx from 'clsx';
import logoImg from '../../assets/img/logo.svg';
import logoDark from '../../assets/img/logo-dark.svg';

interface ThemeLogoProps {
  className?: string;
}

function ThemeLogo({ className }: ThemeLogoProps) {
  return (
    <span className="app-logo-container inline-block" role="img" aria-label="Instapaper">
      <img
        src={logoImg}
        alt=""
        aria-hidden
        className={clsx('app-logo app-logo-light', className)}
      />
      <img
        src={logoDark}
        alt=""
        aria-hidden
        className={clsx('app-logo app-logo-dark', className)}
      />
    </span>
  );
}

export default ThemeLogo;
